import { axiosClient } from '../../clients/axios-client'
import type { DeletePromptResponseDto } from './dtos/prompt'
import { DeletePromptResponseDtoSchema } from './dtos/prompt'

export async function deletePromptById(promptId: string): Promise<void> {
  const trimmedPromptId = promptId.trim()
  if (!trimmedPromptId) {
    throw new Error('Prompt ID is required')
  }

  try {
    const { data } = await axiosClient.delete<DeletePromptResponseDto>(
      `/prompts/${trimmedPromptId}`
    )

    const { success } = DeletePromptResponseDtoSchema.parse(data)
    if (!success) {
      throw new Error(`Prompt deletion failed for prompt ID: ${trimmedPromptId}`)
    }
  } catch (error) {
    console.error(`Prompt deletion failed. Prompt ID: ${trimmedPromptId}`, error)
    throw error
  }
}
